import * as React from "react";
import { Button } from "./Button";
import { rudderStackTrack } from "./Track";
import ACTIONS from "./EventLibrary";
import { Flex } from "@radix-ui/themes";

export function SignupCTA({ displayName, title, description }) {

    return <div className="cta">
        <div className="content">
            <div className="ctaGrid">
                <Flex direction="column" gap="3">
                    <h3>
                        {title ? title : "Don't Have an API Key?"}
                    </h3>
                    {displayName ? <p>Sign up to start building on {displayName}.</p> : ""}
                    <p>
                        {description ? description : "Unlock millions of requests and free archive data on all chains."}
                    </p>
                </Flex>
                <div className="ctaButton">
                    <Button target="_blank" rel="noreferrer noopener"
                        href={"/platform/auth/register/"}
                        onClick={() => {
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'guide-cta-clicked',
                                'pageName': window.location.pathname
                            });
                            rudderStackTrack(ACTIONS.docs_signupcta_clicked, { value: "/platform/auth/register" });
                        }}
                    >
                        Get Started for Free
                    </Button>
                </div>
            </div>

        </div>
        <style jsx>
            {`
              .ctaButton {
                text-align: end;
                vertical-align: start;
                margin-bottom: auto;
              }

              .ctaGrid {
                display: grid;
                grid-template-columns: 1fr 0.5fr;
              }

              .content {
                color: var(--dark);
                background: var(--code-background);
                border: 1px solid var(--code-border);
                line-height: 20px;
                padding: 1.5rem;
                border-radius: var(--border-radius);
                margin-bottom: var(--default-vertical-spacing);
              }

              .cta :global(p:first-of-type) {
                padding: 0;
              }

              h3 {
                margin: 0;
              }

              @media screen and (max-width: 767px) {
                .ctaGrid {
                    grid-template-columns: 1fr;
                }
                .ctaButton {
                    margin-top: 1rem;
                    text-align: left;
                }
              }
            `}
        </style>
    </div>;
}
